import { render, staticRenderFns } from "./ApplicationFooter.vue?vue&type=template&id=078eae6e&scoped=true"
import script from "./ApplicationFooter.vue?vue&type=script&setup=true&lang=ts"
export * from "./ApplicationFooter.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ApplicationFooter.vue?vue&type=style&index=0&id=078eae6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078eae6e",
  null
  
)

export default component.exports